module.exports = __webpack_public_path__ + "img/harmony.41d436c4.png";